<template>
    <div class="slds-setup-assistant__item">
        <article class="slds-setup-assistant__step">
            <div class="slds-setup-assistant__step-summary">
                <div class="slds-media">
                    <div
                        v-if="stepProgress"
                        class="slds-media__figure"
                    >
                        <MAProgressRing
                            :step="step"
                            showStep
                            :isComplete="isComplete"
                            :percent="percent"
                            large
                            :theme="isComplete ? '' : theme"
                        />
                    </div>
                    <div class="slds-media__body slds-m-top_x-small">
                        <div class="slds-media">
                            <div class="slds-setup-assistant__step-summary-content slds-media__body">
                                <h3 class="slds-setup-assistant__step-summary-title slds-text-heading_small">
                                    <slot name="header">Default Header</slot>
                                </h3>
                                <p><slot name="description"></slot></p>
                            </div>
                            <div class="slds-media__figure slds-media__figure_reverse">
                                <slot name="additional-content"></slot>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </article>
    </div>
</template>

<script>
    import MAProgressRing from './MAProgressRing.vue';

    export default {
        name: 'MASetupAssistantItem',
        components: {
            MAProgressRing
        },
        props: {
            step: {
                type: Number,
                default: 1
            },
            stepProgress: {
                type: Boolean,
                default: true
            },
            isComplete: {
                type: Boolean,
                default: false
            },
            percent: {
                type: Number,
                default: 0
            },
            theme: {
                type: String,
                default: 'active'
            }
        }
    };
</script>

<style lang="scss" scoped>
    .slds-setup-assistant__item {
        border-bottom: 1px solid #dddbda;
        padding: 2rem 0;

        &:first-child {
            padding-top: 0;
        }

        &:last-child {
            padding-bottom: 0;
            border-bottom: 0;
        }

        .slds-setup-assistant__step-summary-content {
            text-align: left;

            .slds-setup-assistant__step-summary-title {
                padding-bottom: .5rem;
                font-weight: 700;
            }
        }
    }
</style>
